import React, { useState, useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components/macro";
import { useCookies } from "react-cookie";

import WelcomeModal from "components/WelcomeModal/WelcomeModal";
import getDomain from "utils/getDomain";
import {
	welcomePopupKinds,
	WelcomePopupTypes,
} from "components/WelcomeModal/types";
import { WELCOME_MODAL_CASE } from "../../common/constants/cookies";
import useAuth from "../../contexts/Auth/useAuth";

const GlobalWelcomePopupStyle = createGlobalStyle`
	body{
		overflow:hidden;
	}
`;

const WelcomePopup = () => {
	const { authenticated } = useAuth();
	const { me } = useAuth();
	const [userPopupEnabled, setUserPopupEnabled] = useState<boolean>(false);
	const [showWelcomeModal, setShowWelcomeModal] = useState(true);

	const [currentCase, setCurrentCase] = useState<
		WelcomePopupTypes | undefined
	>();

	const [cookies, setCookie] = useCookies([WELCOME_MODAL_CASE]);

	useEffect(() => {
		if (me) {
			setUserPopupEnabled(me.preferences.showIntroPopup);
		}
	}, [me]);

	const handleCancel = () => {
		setCookie(WELCOME_MODAL_CASE, null, {
			path: "/",
			domain: `${getDomain()}`,
		});

		setShowWelcomeModal(false);
	};

	useEffect(() => {
		const { welcomeModalCase } = cookies;

		// 1st case, user register by himself.
		if (authenticated && welcomeModalCase === welcomePopupKinds.Register) {
			setCurrentCase(welcomePopupKinds.Register);
			return;
		}

		/* 2nd case, user is invited and
		   the complete the registration by himself. */
		if (
			authenticated &&
			welcomeModalCase === welcomePopupKinds.RegisterByInvite
		) {
			setCurrentCase(welcomePopupKinds.RegisterByInvite);
		}

		/* 3rd case, user already registerd by himself. Then he get invited into
		   a organization and he switch into that for the first time. */
		if (
			authenticated &&
			welcomeModalCase === welcomePopupKinds.OrganizationInvite
		) {
			setCurrentCase(welcomePopupKinds.OrganizationInvite);
		}

		/* 4th case, user create his own organization. */
		if (
			authenticated &&
			welcomeModalCase === welcomePopupKinds.CreateOrganization
		) {
			setCurrentCase(welcomePopupKinds.CreateOrganization);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [authenticated, cookies.welcomeModalCase]);

	useEffect(() => {
		if (
			currentCase &&
			[
				welcomePopupKinds.Register,
				welcomePopupKinds.RegisterByInvite,
				welcomePopupKinds.OrganizationInvite,
				welcomePopupKinds.CreateOrganization,
			].includes(currentCase)
		) {
			setShowWelcomeModal(true);
		}
	}, [currentCase]);

	return (
		<StyledContent>
			{currentCase && userPopupEnabled && (
				<>
					<GlobalWelcomePopupStyle />
					<WelcomeModal
						visible={showWelcomeModal}
						onCancel={() => handleCancel()}
						currentCase={currentCase}
					/>
				</>
			)}
		</StyledContent>
	);
};

export const StyledContent = styled.div`
	max-width: 350px;
	margin: auto;
	width: 100%;
	padding: 20px;
	border-radius: 10px;
	&:empty {
		display: none;
	}
`;

export const StyledHeader = styled.div`
	width: 100%;
	display: flex;
	justify-items: center;
	margin-bottom: 20px;
	svg {
		margin: auto;
	}
`;

export const StyledFooter = styled.div`
	width: 100%;
	margin-top: 20px;
	text-align: center;
	button {
		margin: 20px auto auto auto;
	}
`;

export default WelcomePopup;
